import logo from "../../images/UA_Logo_WHT_RGB.png";
import AppBarNav from "./AppBarNav";
import { Link as RouterLink } from "react-router-dom";
import { Typography, Breadcrumbs, Link, Button } from "@mui/material"; // Added Link
import HomeIcon from "@mui/icons-material/Home";
import ProfileMenu from "./components/ProfileMenu";
import { useLocation } from "react-router";
import Logout from "@mui/icons-material/Logout";
import { useState } from "react";

function MasterNavbar() {
	const location = useLocation();

	// --- Logout Logic ---
	function logout() {
		window.history.pushState("", "home", "/");
		window.history.replaceState("", "home", "/");
		sessionStorage.clear();
		window.location.reload();
	}

	const toggleDarkMode = () => {
		console.log("toggle dark mode");
	};

	const [expandedLogout, setExpandedLogout] = useState(false);

	// --- Breadcrumb Logic ---
	const currentPath = location.pathname;

	// 1. Determine if we should show breadcrumbs at all
	const showBreadcrumbs =
		currentPath.startsWith("/reporting") ||
		currentPath.startsWith("/spot") ||
		currentPath.startsWith("/test-scoring");

	const isReportingOrSPOT = currentPath.startsWith("/reporting") || currentPath.startsWith("/spot");

	// 2. Helper to format the text label
	const formatCrumb = (segment) => {
		const lowerSegment = segment.toLowerCase();
		const hasHyphens = segment.includes("-");
		if (hasHyphens) {
			let parts = lowerSegment.split("-");
			parts.forEach((part, index) => {
				if (part === "spot") parts[index] = "SPOT";
				else if (part === "usri") parts[index] = "USRI";
				else if (part === "dept") parts[index] = "Department";
				else if (part === "ddc") parts[index] = "DDC";
				else parts[index] = part.charAt(0).toUpperCase() + part.slice(1);
			});
			return parts.join(" ");
		} else {
			if (segment.toLowerCase() === "spot") return "SPOT";
			if (segment.toLowerCase() === "usri") return "USRI";
		}

		if (segment.toLowerCase() === "exam") return "Exams";
		// Remove dashes and capitalize first letter of words
		return segment.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
	};

	// 3. Generate segments array (removed the useState/useEffect overhead)
	const pathnames = currentPath.split("/").filter((x) => x);

	if (location.pathname !== "/SignIn" && !location.pathname.includes("/sso/callback")) {
		return (
			<div
				className={`${showBreadcrumbs ? "h-[calc(13rem+8px)]" : "h-[calc(11rem+8px)]"} bg-digitalWhite `}
			>
				{/* --- Header / Logo Section --- */}
				<div className="flex bg-primary justify-between items-center px-6 md:px-14 h-28 ">
					<Link component={RouterLink} to="/" className="flex items-center gap-4 no-underline">
						<img src={logo} alt="UofA logo" className="h-[50px] w-auto" />
						<div className="flex flex-col md:justify-center justify-end h-[50px]">
							<span className="text-lg md:text-base text-white font-medium tracking-wide">
								TSQS
							</span>
							<span className="text-[#f2cd00] text-xl lg:text-2xl font-light leading-tight hidden md:block">
								{isReportingOrSPOT
									? `Student Perspectives of Teaching`
									: "Test Scoring & Questionnaire Services"}
							</span>
						</div>
					</Link>
					<div className="flex items-center gap-2 ">
						<button
							onClick={logout}
							onMouseEnter={() => setExpandedLogout(true)}
							onMouseLeave={() => setExpandedLogout(false)}
							className="hidden md:flex items-center gap-2 text-white hover:text-gray-200 transition-colors px-3 py-2 rounded-md hover:bg-green-800"
						>
							<span
								className={`transition-all duration-300 ease-in-out font-light ${
									expandedLogout
										? "opacity-100 translate-x-0 w-auto"
										: "opacity-0 translate-x-8 w-0 overflow-hidden"
								}`}
							>
								Log Out
							</span>
							<Logout />
						</button>
						<ProfileMenu Logout={logout} toggleDarkMode={toggleDarkMode} />
					</div>
				</div>

				{/* --- Main Nav --- */}
				<div
					className={`border-b border-gray-200 flex justify-center z-10 h-16 ${!showBreadcrumbs ? "shadow-2xl" : ""}`}
				>
					<AppBarNav />
				</div>

				{/* --- Breadcrumbs Section --- */}
				{showBreadcrumbs && (
					<div className="h-8 w-full bg-digitalWhite pl-4 md:pl-8 flex items-center shadow-2xl mb-2 border-b border-gray-200 ">
						<Breadcrumbs separator="›" className="text-sm">
							<Link
								component={RouterLink}
								to="/"
								underline="hover"
								className="flex items-center gap-1 text-primary hover:text-green-800 transition-colors font-light"
							>
								<HomeIcon sx={{ fontSize: 18 }} />
								<span>Home</span>
							</Link>

							{pathnames.map((value, index) => {
								const last = index === pathnames.length - 1;
								const to = `/${pathnames.slice(0, index + 1).join("/")}`;
								const label = formatCrumb(value);

								return last ? (
									<span key={to} className="text-gray-700 font-normal">
										{label}
									</span>
								) : (
									<Link
										component={RouterLink}
										to={to}
										underline="hover"
										key={to}
										className="text-gray-600 hover:text-primary transition-colors font-light"
									>
										{label}
									</Link>
								);
							})}
						</Breadcrumbs>
					</div>
				)}
			</div>
		);
	}
}

export default MasterNavbar;
